export const workflowSteps = [
  { id: 1, label: 'Pipeline Ingestion', description: 'Connect your repeatable workflow sources (webhooks, CRMs, or API logs) to the OpsPrism ingestion engine.', status: 'complete' },
  { id: 2, label: 'Heuristic Mapping', description: 'OpsPrism automatically identifies the "Happy Path" and flags structural deviations in real-time.', status: 'complete' },
  { id: 3, label: 'Bottleneck Detection', description: 'The Radar module identifies specific nodes causing latency or task pile-ups.', status: 'active' },
  { id: 4, label: 'Playbook Assignment', description: 'Match the identified bottleneck with a pre-configured automation protocol.', status: 'pending' },
  { id: 5, label: 'Execution & Scale', description: 'Trigger manual or automated remediation to clear the queue and restore throughput.', status: 'pending' },
  { id: 6, label: 'Executive Reporting', description: 'Generate a post-mortem report showing SLA recovery and team efficiency gains.', status: 'pending' }
];

export const faqData = [
  {
    q: "What exactly does OpsPrism solve?",
    a: "OpsPrism eliminates the 'black box' of operational workflows. It provides mission-critical visibility for teams managing thousands of repeatable tasks, flagging bottlenecks before they become SLA breaches."
  },
  {
    q: "Is this dummy data or a live connection?",
    a: "This current environment is a high-fidelity simulation designed to show how OpsPrism handles real-world operational stress. In production, these cards represent live data from your integrated tech stack."
  },
  {
    q: "How are automation playbooks triggered?",
    a: "Playbooks can be triggered manually by an operator or automatically based on threshold-based 'System Stress' levels detected by the Bottleneck Radar."
  },
  {
    q: "Does OpsPrism store private customer data?",
    a: "No. OpsPrism operates at the metadata level, monitoring workflow performance and system health without needing access to the sensitive content of individual tasks."
  },
  {
    q: "What are the pricing tiers for OpsPrism?",
    a: "We offer 'Base Station' for early-stage teams and 'Command Center' for enterprise-scale operations. Contact LingLink AI or DigLab AI for a custom quote."
  }
];

export const sampleModuleData = {
  taskQueues: [
    { id: 'TQ-102', task: 'Customer Onboarding', count: 142, status: 'Congested', trend: 'up' },
    { id: 'TQ-105', task: 'Invoice Processing', count: 89, status: 'Optimal', trend: 'stable' },
    { id: 'TQ-109', task: 'API Validation', count: 12, status: 'Clear', trend: 'down' }
  ],
  slaBoard: [
    { metric: 'Avg Resolution Time', target: '< 4h', current: '3.2h', health: 'good' },
    { metric: 'Queue Throughput', target: '> 500/m', current: '380/m', health: 'warning' },
    { metric: 'System Uptime', target: '99.99%', current: '99.98%', health: 'good' }
  ]
};

export const sampleRecords = [
  { id: 'OP-9421', task: 'Redis Cluster Re-sharding', owner: 'Alex Chen', priority: 'High', status: 'In Progress', deadline: '2024-05-24 14:00', load: '82%' },
  { id: 'OP-9422', task: 'Ingress Load Balancing', owner: 'Sarah Miller', priority: 'Medium', status: 'Completed', deadline: '2024-05-24 10:30', load: '14%' },
  { id: 'OP-9423', task: 'Backup Integrity Audit', owner: 'System-Auto', priority: 'Low', status: 'Scheduled', deadline: '2024-05-25 02:00', load: '5%' },
  { id: 'OP-9424', task: 'API Gateway Rate Limit Adjust', owner: 'Mike Ross', priority: 'Critical', status: 'Warning', deadline: '2024-05-24 12:15', load: '95%' },
  { id: 'OP-9425', task: 'Database Index Optimization', owner: 'Elena V', priority: 'Medium', status: 'Paused', deadline: '2024-05-24 18:00', load: '45%' },
];